<template>
    <div class="unit-inputs">
        <el-select
            :value="unitType"
            placeholder="Select"
            @change="$emit('update:unitType', $event)"
        >
            <el-option
                v-for="option in $data.$unitTypeOptions"
                :key="option"
                :label="option"
                :value="option"
            >
            </el-option>
        </el-select>
        <el-input-number
            :value="unitSize"
            :controls="false"
            placeholder="Quantity (eg. 330mL)"
            @change="$emit('update:unitSize', $event)"
        ></el-input-number>
        <el-select
            :value="unitOfMeasurement"
            @change="$emit('update:unitOfMeasurement', $event)"
        >
            <el-option
                v-for="option in $data.$uomOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value"
            >
            </el-option>
        </el-select>
    </div>
</template>

<script>
import UnitDropdownOptionsMixin from "Mixins/UnitDropdownOptionsMixin";

export default {
    mixins: [UnitDropdownOptionsMixin],
    props: {
        unitType: String,
        unitSize: String | Number,
        unitOfMeasurement: String | Number,
    },
};
</script>

<style lang="scss" scoped>
.unit-inputs {
    /deep/ input.el-input__inner {
        text-align: left;
    }

    div {
        margin-right: 10px;

        &:last-child {
            margin-right: 0;
        }
    }
}
</style>
